"use client";
//#region packages/@mantine/core/src/core/Box/get-box-style/get-box-style.ts
function mergeStyles(styles, theme) {
	if (Array.isArray(styles)) return [...styles].reduce((acc, item) => ({
		...acc,
		...mergeStyles(item, theme)
	}), {});
	if (typeof styles === "function") return styles(theme);
	if (styles == null) return {};
	return styles;
}
function getBoxStyle({ theme, style, vars, styleProps }) {
	const _style = mergeStyles(style, theme);
	const _vars = mergeStyles(vars, theme);
	return {
		..._style,
		..._vars,
		...styleProps
	};
}
//#endregion
export { getBoxStyle };

//# sourceMappingURL=get-box-style.mjs.map